import { loginApi, getCurrentUserApi } from 'api/auth';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { StoreContext } from './useStore';

export const useAuth = () => {
  const { dispatch, state } = useContext(StoreContext);
  const [lerror, setLerror] = useState(null);
  const queryClient = useQueryClient();

  const setUser = useCallback((data) => {
    dispatch({
      type: 'setUser',
      payload: data,
    });
  }, []);

  const logout = useCallback(() => {
    dispatch({
      type: 'logout',
    });
    window.location = '/';
  }, []);

  const loginMutation = useMutation((payload) => loginApi(payload), {
    onSuccess: (res) => {
      if (res?.loginStatus !== 'MFA_REQUIRED') {
        setLerror(res?.message || 'Invalid username or password');
        dispatch({ type: 'loginFail' });
      }
      return res;
    },
    onError: () => {
      dispatch({
        type: 'loginFail',
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries('auth/signin');
    },
  });

  const login = async (data) => {
    try {
      dispatch({ type: 'login' });
      return await loginMutation.mutateAsync(data);
    } catch (error) {
      dispatch({ type: 'loginFail' });
      throw error;
    }
  };

  const getCurrentUser = async (data) => {
    try {
      dispatch({
        type: 'currentUser',
      });
      await currentUserMutation.mutateAsync(data);
    } catch (error) {
      //
    }
  };

  return {
    user: state.user,
    login,
    logout,
    setUser,
    isAuthenticated: !!localStorage.getItem('sessionToken'),
    loading: state.loading,
    loginError: loginMutation.error,
    lerror,
    roleId: state.roleId,
  };
};

export const useHasRole = (roles) => {
  const { state } = useContext(StoreContext);
  const [hasRole, setHasRole] = useState(false);

  useEffect(() => {
    setHasRole(!!roles?.find((e) => e === state.user?.role));
  }, [state.user]);

  return hasRole || !roles;
};
